import React from 'react'
import PropTypes from 'prop-types'
import { Provider, connect } from '@picostate/react'
import cx from 'classnames'
import Helmet from 'react-helmet'

import Header from '@/header.js'
import CanvasWrapper from '@/backgrounds/canvasWrapper.js'
import '../styles/main.css'
import store from '../state/store.js'

const LayoutInner = connect(state => ({
  backgroundColor: state.backgroundColor,
  background: state.background,
  page: state.page
}))((props) => (
  <div className={cx('a-color site', props.page, {
    'cw': props.backgroundColor === false,
    'cb': props.backgroundColor
  })}>
    <div className={cx('site__background fix top left x y', props.background)}>
      <CanvasWrapper background={props.background} />
    </div>
    <div className='rel z1'>{props.children}</div>
  </div>
))

class Layout extends React.Component {
  componentDidMount () {
    window.addEventListener('resize', () => {
      if (store.state.navOpen) {
        store.hydrate({
          navOpen: false
        })()
      }
    })
    console.groupCollapsed('Site credits 🍝')
    console.log('Branding, Design & Development by The Couch https://thecouch.nyc')
    console.groupEnd()
  }
  render () {
    return (
      <Provider store={store}>
        <LayoutInner>
          <Helmet>
            <html lang='en' />
            <meta property='og:locale' content='en_US' />
            <meta property='og:site_name' content='re:store' />
            <meta name='twitter:site' content='@restore' />
            <meta name='twitter:card' content='summary_large_image' />
            <meta http-equiv='Accept-CH' content='DPR, Width, Viewport-Width' />
          </Helmet>
          <Header />
          <main>
            {this.props.children}
          </main>
        </LayoutInner>
      </Provider>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout
